var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('el-container',[_c('Header',{on:{"menu-select":_vm.handleMenuSelect}}),_c('el-main',[_c('router-view')],1)],1),_c('ContactFloating')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }